"use strict";

exports.__esModule = true;
exports.URL = exports.STATUS_UPLOADING = exports.STATUS_SUCCESS = exports.STATUS_READY = exports.STATUS_ERROR = void 0;
exports.base64toFile = base64toFile;
exports.evalOpts = evalOpts;
exports.generateKey = generateKey;
exports.getQueryString = getQueryString;
exports.getiPhoneVersion = getiPhoneVersion;
exports.isWxWork = void 0;
exports.loadJs = loadJs;
exports.newFile = newFile;
exports.processFile = processFile;
exports.processFiles = processFiles;
exports.urlToFile = urlToFile;
exports.urlsToFiles = urlsToFiles;
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/web.url.js");
require("core-js/modules/web.url-search-params.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.string.search.js");
require("core-js/modules/es.array.join.js");
require("core-js/modules/es.array.index-of.js");
require("core-js/modules/es.string.trim.js");
require("core-js/modules/es.string.match.js");
require("core-js/modules/es.array-buffer.slice.js");
require("core-js/modules/es.typed-array.uint8-array.js");
require("core-js/modules/es.typed-array.copy-within.js");
require("core-js/modules/es.typed-array.every.js");
require("core-js/modules/es.typed-array.fill.js");
require("core-js/modules/es.typed-array.filter.js");
require("core-js/modules/es.typed-array.find.js");
require("core-js/modules/es.typed-array.find-index.js");
require("core-js/modules/es.typed-array.for-each.js");
require("core-js/modules/es.typed-array.includes.js");
require("core-js/modules/es.typed-array.index-of.js");
require("core-js/modules/es.typed-array.iterator.js");
require("core-js/modules/es.typed-array.join.js");
require("core-js/modules/es.typed-array.last-index-of.js");
require("core-js/modules/es.typed-array.map.js");
require("core-js/modules/es.typed-array.reduce.js");
require("core-js/modules/es.typed-array.reduce-right.js");
require("core-js/modules/es.typed-array.reverse.js");
require("core-js/modules/es.typed-array.set.js");
require("core-js/modules/es.typed-array.slice.js");
require("core-js/modules/es.typed-array.some.js");
require("core-js/modules/es.typed-array.sort.js");
require("core-js/modules/es.typed-array.subarray.js");
require("core-js/modules/es.typed-array.to-locale-string.js");
require("core-js/modules/es.typed-array.to-string.js");
require("core-js/modules/es.promise.js");
require("core-js/modules/es.array.map.js");
var inBrowser = typeof window !== 'undefined';
var UA = inBrowser ? window.navigator.userAgent.toLocaleLowerCase() : '';
var URL = inBrowser ? window.URL || window.webkitURL || window.mozURL : null;
exports.URL = URL;
var STATUS_READY = 'ready';
exports.STATUS_READY = STATUS_READY;
var STATUS_UPLOADING = 'uploading';
exports.STATUS_UPLOADING = STATUS_UPLOADING;
var STATUS_ERROR = 'error';
exports.STATUS_ERROR = STATUS_ERROR;
var STATUS_SUCCESS = 'success';
exports.STATUS_SUCCESS = STATUS_SUCCESS;
function generateKey(file) {
  var key = (Date.now() + Math.random()).toString(36).replace('.', '');
  var type = file.type && file.type.split('/')[1] || 'mp4';
  return key + "." + type;
}
var isWxWork = function () {
  return /wxwork/i.test(UA);
}();
exports.isWxWork = isWxWork;
function getQueryString(name) {
  if (!inBrowser) {
    return '';
  }
  var arr = window.location.search.substr(1).split('&');
  for (var i = 0, l = arr.length; i < l; i++) {
    var item = arr[i].split('=');
    if (item.shift() === name) {
      return decodeURIComponent(item.join('='));
    }
  }
  return '';
}
function processFile(file, i, eachProcessFile, cb) {
  eachProcessFile(file, function (file) {
    // eslint-disable-next-line no-use-before-define
    var item = newFile(file.name, file.size, STATUS_READY, 0, file, file.type);
    cb(item, i);
  });
}
function processFiles(files, eachProcessFile, eachCb, cb) {
  var processFileFun = function processFileFun(file, cb) {
    cb(file);
  };
  var fileItems = [];
  var len = files.length;
  var processedLen = 0;
  var eachProcess = processFileFun;
  for (var i = 0; i < len; i++) {
    if (files[i] && files[i].type && files[i].type.indexOf('video') !== -1) {
      eachProcess = processFileFun;
    } else {
      eachProcess = eachProcessFile;
    }
    // eslint-disable-next-line no-loop-func
    processFile(files[i], i, eachProcess, function (item, index) {
      processedLen++;
      fileItems[index] = item;
      eachCb(item, index);
      if (processedLen === len) {
        return cb(fileItems);
      }
    });
  }
}
function newFile(name, size, status, progress, file, type) {
  if (name === void 0) {
    name = '';
  }
  if (size === void 0) {
    size = 0;
  }
  if (status === void 0) {
    status = '';
  }
  if (progress === void 0) {
    progress = 0;
  }
  if (file === void 0) {
    file = null;
  }
  var base64 = file && file.base64 || '';
  // eslint-disable-next-line no-use-before-define
  var url = base64 ? '' : createURL(file);
  return {
    name: name,
    size: size,
    url: url,
    base64: base64,
    status: status,
    progress: progress,
    file: file,
    type: type,
    response: ''
  };
}
function createURL(file) {
  if (file && URL) {
    return URL.createObjectURL(file);
  }
  return '';
}
function evalOpts(data) {
  if (typeof data === 'function') {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    return data.apply(this, args);
  }
  return data;
}
function getiPhoneVersion(ua) {
  ua = ua.split('iphone os')[1];
  ua = ua.split('like')[0];
  ua = ua.trim().replace('_', '.');
  return ua;
}
function loadJs(url, callback) {
  var script = document.createElement('script');
  script.type = 'text/javascript';
  if (typeof callback === 'function') {
    if (script.readyState) {
      script.onreadystatechange = function () {
        if (script.readyState === 'loaded' || script.readyState === 'complete') {
          script.onreadystatechange = null;
          callback();
        }
      };
    } else {
      script.onload = function () {
        callback();
      };
    }
  }
  script.src = url;
  document.body.appendChild(script);
}
function base64toFile(base64) {
  var arr = base64.split(',');
  var type = arr[0].match(/:(.*?);/)[1];
  var lastModified = Date.now();
  var filename = lastModified + "." + type.split('/')[1];
  var bstr = atob(arr[1]);
  var u8arr = new Uint8Array(bstr.length);
  var n = bstr.length;
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, {
    type: type,
    lastModified: lastModified
  });
}
function urlsToFiles(urls) {
  return Promise.all(urls.map(function (url) {
    return urlToFile(url);
  }));
}
function urlToFile(url) {
  return new Promise(function (resolve, reject) {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.responseType = 'blob';
    xhr.onload = function () {
      if (xhr.status === 200) {
        var blob = xhr.response;
        console.log('blob', blob);
        var fileRender = new FileReader();
        fileRender.onload = function () {
          resolve(base64toFile(fileRender.result));
        };
        fileRender.readAsDataURL(blob);
      } else {
        reject(new Error('Failed to load file'));
      }
    };
    xhr.onerror = function () {
      reject(new Error('Failed to load file'));
    };
    xhr.send();
  });
}